import { useMemo } from 'react';
import { dayjs } from '@iqx-web/libs/dayjs';
import { StyledDatePicker } from './DatePicker.styles';
import type { DatePickerProps } from './types';

const { tz } = dayjs;

type Props = DatePickerProps & {
  timeZoneValue?: string;
};

export function DatePicker({
  onChange,
  timeZoneValue,
  value,
  format = 'YYYY-MM-DD',
  placeholder = 'Select Date',
  ...rest
}: Props) {
  const _onChange = (date: DatePickerProps['value']) => {
    if (onChange) onChange(date ?? null, '');
  };

  const currentTimeZone = timeZoneValue || tz.guess();

  const newValue = useMemo(
    () => (value ? dayjs(value).tz(currentTimeZone) : null),
    [value, currentTimeZone],
  );

  return (
    <StyledDatePicker
      onChange={_onChange}
      format={format}
      placeholder={placeholder}
      value={newValue}
      {...rest}
    />
  );
}
